import React from "react";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import VisionSection from "../components/VisionSection";
import FacilityManagement from "../components/FacilityManagement";
import TransitionSection from "../components/TransitionSection";
import ReportsSection from "../components/ReportsSection";
import ServicesSection from "../components/ServicesSection";
import SecuritySolutions from "../components/SecuritySolutions";
import CostControlSection from "../components/CostControlSection";
import ClientsSection from "../components/ClientsSection";
import ContactSection from "../components/ContactSection";

export default function Home() {
  return (
    <>
         <Hero />
      <div style={{background:'white' }}>
      <AboutSection />
      <VisionSection />
      <FacilityManagement />
      <TransitionSection />
      <ServicesSection />
      <ReportsSection />
      <SecuritySolutions />
      <CostControlSection />
      <ClientsSection />
      <ContactSection />
      </div>
    </>
  );
}
